import React from "react";
import "../tracker/tracker.css";
import axios from "axios";
import jQuery from "jquery";
import Header from "../tracker/common/header";
import Footer from "../tracker/common/footer";

class IndiaData extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      apptitle: this.props.apptitle,
      covidData: [],
      covidStatesIN: []
    };
  }

  componentDidMount = (e) => {
    axios
      .get("https://api.covid19india.org/data.json", this.state)
      .then((res) => {
        // console.log(res.data);
        if (res.data) {
          //alert("Data Recieved Successfully!!");
          //var covidC = JSON.stringify(res.data.Countries);
          //console.log(res.data);
          //console.log(res.data.statewise);
          var Timestamp = res.data.Date;
          var date = new Date(Timestamp);
          //var dateTime = date.toDateString();
          var formattedDate =
            date.getDate() +
            "/" +
            (date.getMonth() + 1) +
            "/" +
            date.getFullYear();
          // var dateTime = formattedDate.toDateString();

          var formattedTime =
            date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
          jQuery("#Timestamp").html(formattedDate);
          jQuery("#datestamp").html(formattedTime);
          //console.log(formattedDate);
          var covidstateSort = res.data.statewise.slice(1, 37);
          var covidC = covidstateSort;

          this.setState({ covidData: res.data });
          this.setState({ covidStatesIN: covidC });
        }
      })
      .catch((error) => {
        console.log(error);
      });

    jQuery("#selectStateIN").change(function () {
      //alert(jQuery("option:selected", this).attr("data-state"));
      jQuery("#stateName").html(
        jQuery("option:selected", this).attr("data-State")
      );
      jQuery("#TotalConfirmed").html(
        jQuery("option:selected", this).attr("confirmed")
      );
      jQuery("#TotalRecovered").html(
        jQuery("option:selected", this).attr("recovered")
      );
      jQuery("#TotalDeaths").html(
        jQuery("option:selected", this).attr("deaths")
      );
      jQuery("#TotalActive").html(
        jQuery("option:selected", this).attr("active")
      );

      jQuery("#lastUpdated").html(
        jQuery("option:selected", this).attr("lastupdatedtime")
      );
    });

    // jQuery("#selectStateIN").html(
    //   jQuery("option", jQuery("#selectStateIN")).sort(function (a, b) {
    //     var arel = parseInt(jQuery(a).attr("data-state"), 10) || 0;
    //     var brel = parseInt(jQuery(b).attr("data-state"), 10) || 0;
    //     return arel == brel ? 0 : arel < brel ? -1 : 1;
    //   })
    // );
  };

  refreshdata = (e) => {
    e.preventDefault();
    location.reload();
  };

  render() {
    return (
      <section className="tracker-section">
        <Header title={this.props.apptitle} />

        <div className="container bodyContainer">
          <div className="row">
            <div className="col-12">
              <div className="details-column row">
                <div className="col-12">
                  <label> Choose Country</label>
                  <select className="form-control" id="selectState">
                    <option key="null" value="null">
                      - India
                    </option>
                  </select>
                </div>
              </div>
              <div className="details-column row" id="selectStateColumn">
                <div className="col-12">
                  <label> Select State</label>
                  <select className="form-control" id="selectStateIN">
                    <option key="null" value="null">
                      - Select State
                    </option>
                    {this.state.covidStatesIN.map((covidStates) => (
                      <option
                        key={covidStates.statecode}
                        value={covidStates.statecode}
                        data-state={covidStates.state}
                        active={covidStates.active}
                        confirmed={covidStates.confirmed}
                        deaths={covidStates.deaths}
                        lastupdatedtime={covidStates.lastupdatedtime}
                        recovered={covidStates.recovered}
                        totaldeaths={covidStates.totaldeaths}
                      >
                        - {covidStates.state}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="details-column row">
                <div className="col-12">
                  <div className="updated-time-column">
                    <p>
                      <i className="fa fa-bell"></i>&nbsp; Last Updated &nbsp;
                      <span id="lastUpdated"></span> &nbsp;
                    </p>
                  </div>
                </div>
              </div>
              <div className="details-column row">
                <div className="col-12">
                  <p>
                    <strong>State Name: </strong>
                  </p>
                  <h2>
                    <strong>
                      <span id="stateName">****</span>
                    </strong>
                  </h2>
                </div>
              </div>
              <div className="details-column row">
                <div className="col-6">
                  <div className="col-inner red-col">
                    <p>Confirmed:</p>
                    <h2>
                      <strong>
                        <span id="TotalConfirmed">****</span>
                      </strong>
                    </h2>
                  </div>
                </div>
                <div className="col-6">
                  <div className="col-inner blue-col">
                    <p>Active</p>
                    <h2>
                      <strong>
                        <span id="TotalActive">****</span>
                      </strong>
                    </h2>
                  </div>
                </div>
              </div>
              <div className="details-column row">
                <div className="col-6">
                  <div className="col-inner green-col">
                    <p>Recovered</p>
                    <h2>
                      <strong>
                        <span id="TotalRecovered">****</span>
                      </strong>
                    </h2>
                  </div>
                </div>
                <div className="col-6">
                  <div className="col-inner red-col">
                    <p>Deceased</p>
                    <h2>
                      <strong>
                        <span id="TotalDeaths">****</span>
                      </strong>
                    </h2>
                  </div>
                </div>
              </div>
              <br />
              <br />
              <div className="row">
                <Footer />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default IndiaData;
